<template>
  <div>
    <v-data-table
      v-model="selected"
      :show-select="totaleRighe > 0"
      color="blue lighten-4"
      item-key="codice"
      :headers="headers"
      :items="righeDocumento"
      :options.sync="options"
      :server-items-length="totaleRighe"
      :loading="loading"
      class="elevation-1"
      :disable-sort="true"
      :footer-props="{
        itemsPerPageOptions: [5, 10, 15, 50, 100]
      }"
      dense
    >
    </v-data-table>
  </div>
</template>

<script>
  import documenti from '@/services/documentiService.js'
  import _ from 'lodash'
  
  export default {
    components: {
    },
    props: {
      idDocumento: String
    },
    data () {
      return {
        totaleRighe: 0,
        righeDocumento: [],
        selected: [],
        loading: true,
        options: {},
        headers: [
          { text: 'Codice', value: 'prodotto.codice', align: 'start'},
          { text: 'Descrizione', value: 'descrizione' },
          { text: 'Quantità', value: 'quantita', align: 'end' },
          { text: 'Prezzo Unitario', value: 'valore.prezzoUnitario' , align: 'end'},
          { text: 'Sconto %', value: 'sconti' , align: 'end'},
          { text: 'Importo Unitario', value: 'valore.importoUnitario' , align: 'end'},
          { text: 'Importo Totale', value: 'valore.importoTotale' , align: 'end'},
          { text: 'Iva', value: 'aliquotaIva.descrizione' , align: 'end'}
        ],
        expanded: [],
        singleExpand: false,
        modelloDocumento: null,
        filtri: null,
        tab: null,
        pathEtichettePrefix: '',
        usaQtaAnagrafica: false, // TODO: da configurazioni
        salta: 0,
        filtroElementi: null,
        tipoStampa: '',
        report: '',
        erroreDocumento: ''
      }
    },
    computed: {
      refreshList() { // Verificare
        return this.$store.getters['documenti/refreshDettaglio']
      }
    },
    watch: {
      options: {
        async handler () {
          await this.getDataFromApi()
        },
        deep: true
      },
      async refreshList(value) {
        if (value) {
          await this.getDataFromApi()
          this.$store.commit('documenti/CLEAR_REFRESH', 'dettaglio')
        }
      },
      async idDocumento(value) {
        if (value) {
          await this.getDataFromApi()
        }
      }
    },
    async mounted () {
    },
    methods: {
/*       backClick() {
        this.$emit('back')
      }, */
      async onRicerca(filtri) {
        this.filtri = filtri
        await this.getDataFromApi()
      },
      rigaSconti(v) {
        const sc = []
        v.sconto1 && sc.push (v.sconto1)
        v.sconto2 && sc.push (v.sconto2)
        v.sconto3 && sc.push (v.sconto3)
        v.sconto4 && sc.push (v.sconto4)
        return sc.join('+')
      },
      async getDataFromApi () {
        try {
          this.loading = true
          const documento = await documenti.getDocumento(this.idDocumento)
          this.totaleRighe = documento.righe.length
          this.righeDocumento = documento.righe.map (x => {
            return {
              sconti: this.rigaSconti(x.valore), 
              descrizione: x.descrizione || _.get(x, 'prodotto.descrizione', ''),
              ...x
            }
          })
        } catch(err) {
          this.righeDocumento = []
          this.totaleRighe = 0
        } finally {
          this.loading = false
        }
      },
      datiVisualizzazione(documenti) {
        const elaborati = documenti.map(el => {
         // const nominativo = (el.anagrafica.fornitore && el.anagrafica.fornitore.descrizione) || (el.anagrafica.cliente && el.anagrafica.cliente.descrizione)
          const nominativo = (el.anagrafica.fornitore && el.anagrafica.fornitore.codice) || (el.anagrafica.cliente && el.anagrafica.cliente.codice)
          return { ...el, c_nominativo: nominativo }
        }) 
        return elaborati
      },
      deleteDatiVisualizzazione(documento) {
        let locDocumento = {...documento}
        delete locDocumento.c_nominativo
        delete locDocumento.appoggio
        return locDocumento
      },
      annullaSelezione() {
        while(this.selected.length > 0) { this.selected.pop() }
      }
    }
  }
</script>

<style lang="scss">
  tr.v-data-table__expanded__content  { // TODO: Solo su questa pagina !
    box-shadow: none !important;
  }
    td.ddtSelected {
    border-style: solid!important;
    border-width: 2px!important;
    border-color: #1976d2 !important;
  }
</style>
